import { navigate } from "gatsby";
import { scroller } from "react-scroll";

import { SCROLL_ELEMENT_OFFSET } from "@config/consts";
import { PATHS } from "@config/app.routing";

import { AVAILABLE_LANGS } from "@typings/globals";

import { useAuth, useAuthManager } from "@hooks/useAuth";

import { Maybe, PrismicLinkField } from "@www/graphql-types";

export const useProceedRedirect = () => {
  const { openLoginModal } = useAuthManager();
  const { isUserLoggedIn } = useAuth();

  return (
    language: AVAILABLE_LANGS,
    link?: Maybe<PrismicLinkField>,
    requiresAuthorization?: boolean,
  ) => {
    // return to the home page if no link is provided
    if (!link) {
      navigate(`/${language}`);
      return;
    }

    const redirect = () => {
      switch (link.link_type) {
        case "Document": {
          navigate(`/${language}/${link.slug}`);
          return;
        }
        case "Web": {
          if (!link.url) return;

          // scroll to the element if the link is an anchor
          if (link.url.indexOf("#") === 0) {
            scroller.scrollTo(link.url.slice(1), {
              smooth: true,
              offset: SCROLL_ELEMENT_OFFSET,
            });

            return;
          }

          // open the link
          const url = `/${language}${PATHS.CLIENT_APP}#${link.url ?? ""}`;

          window.open(
            link.url.indexOf("http") === -1 ? url : link.url,
            link.target || "_self",
          );

          return;
        }
        default:
          return;
      }
    };

    if (requiresAuthorization && !isUserLoggedIn) {
      openLoginModal({ redirectAfterLogin: redirect });
      return;
    }

    redirect();
  };
};
